import { render, staticRenderFns } from "./EditNotaryModal.vue?vue&type=template&id=5baf1cc1"
import script from "./EditNotaryModal.vue?vue&type=script&lang=js"
export * from "./EditNotaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports